import store from '@/state/store'

function loadLists() {
  const fileLists = require.context('./list', true, /[A-Za-z0-9-_,\s]+\.json$/i)

  const lists = {}
  fileLists.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const list = matched[1]
      lists[list] = fileLists(key)
    }
  })
  return lists
}

const local = store.state.layout.local;
const key = 'name_' + local;
const lists = loadLists();

const main_section = lists.main_section.map((x)=> { return { id: x.id, name: x[key] } })  
const sub_section = lists.sub_section.map((x)=> { return { id: x.id, name: x[key] } })  
const certificate = lists.certificate.map((x)=> { return { id: x.id, name: x[key] } })  
const city = lists.city.map((x)=> { return { id: x.id, name: x[key] } })  
const gender = lists.gender.map((x)=> { return { id: x.id, name: x[key] } })  
const search_option = lists.search_option.map((x)=> { return { id: x.id, name: x[key] } })  
const country = lists.country.map((x)=> { return { id: x.id, name: x[key], code:x.code, phone_code:x.phone_code, phone_length:x.phone_length } })  

export { main_section, sub_section, certificate, city, country, gender, search_option }


